export default __webpack_public_path__ + "static/media/icon_only-transparent.50da98e8.svg";